import { useState } from "react";
import { BIZ, SOCIALS } from "../data/content";

const CONTACT_INFO = [
  { icon: "📞", title: "Toll-Free",  text: "1800 890 0803" },
  { icon: "📧", title: "Email Us",   text: "contact@buyp.in" },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", type: "", msg: "" });
  const [sent, setSent] = useState(false);

  const update = (key, val) => setForm((prev) => ({ ...prev, [key]: val }));

  const handleSubmit = () => {
    if (form.name && form.email && form.msg) setSent(true);
  };

  return (
    <div className="page">

      {/* ── HEADER ── */}
      <div className="contact-top">
        <div style={{ position: "relative", zIndex: 2, maxWidth: 520 }}>
          <div className="eyebrow">Contact Us</div>
          <h1 style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)", fontWeight: 900, lineHeight: 1.1, marginBottom: 14, fontFamily: "'Fraunces',serif" }}>
            Let's get your<br />restaurant <em>set up</em>
          </h1>
          <p style={{ color: "rgba(255,255,255,.5)", fontSize: "1rem", lineHeight: 1.75 }}>
            Questions, demo requests, or a quick chat — our team is available Monday to Saturday.
          </p>
        </div>
      </div>

      {/* ── BODY ── */}
      <div className="contact-body">

        {/* Left: info + social */}
        <div>
          <div className="ci-cards">
            {CONTACT_INFO.map((c, i) => (
              <div className="ci-c" key={i}>
                <div className="ci-ico">{c.icon}</div>
                <div>
                  <h4>{c.title}</h4>
                  <p>{c.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, color: "var(--muted)", marginBottom: 12 }}>
              Follow Us
            </div>
            <div className="soc-row">
              {SOCIALS.map((s, i) => (
                <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="soc-btn">
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Right: contact form */}
        <div className="cf-card">
          {sent ? (
            <div className="succ">
              <div className="succ-ic">🎉</div>
              <h3>Message Sent!</h3>
              <p>Our team will get back to you within 24 hours.</p>
              <button className="sub-btn" style={{ maxWidth: 200, margin: "0 auto" }} onClick={() => setSent(false)}>
                Send Another
              </button>
            </div>
          ) : (
            <>
              <div className="cf-title">Send us a message</div>
              <div className="f-row">
                <div className="fd">
                  <label>Full Name *</label>
                  <input placeholder="Your name" value={form.name} onChange={(e) => update("name", e.target.value)} />
                </div>
                <div className="fd">
                  <label>Phone</label>
                  <input placeholder="+91 98765 43210" value={form.phone} onChange={(e) => update("phone", e.target.value)} />
                </div>
              </div>
              <div className="fd">
                <label>Email *</label>
                <input type="email" placeholder="you@restaurant.com" value={form.email} onChange={(e) => update("email", e.target.value)} />
              </div>
              <div className="fd">
                <label>Business Type</label>
                <select value={form.type} onChange={(e) => update("type", e.target.value)}>
                  <option value="">Select your business type</option>
                  {BIZ.map((b, i) => (
                    <option key={i} value={b.label}>{b.icon} {b.label}</option>
                  ))}
                </select>
              </div>
              <div className="fd">
                <label>Message *</label>
                <textarea placeholder="Tell us about your restaurant..." value={form.msg} onChange={(e) => update("msg", e.target.value)} />
              </div>
              <button className="sub-btn" onClick={handleSubmit}>Send Message →</button>
              <p style={{ textAlign: "center", color: "var(--muted)", fontSize: "0.78rem", marginTop: 12 }}>
                Or call <strong style={{ color: "var(--ink)" }}>1800 890 0803</strong>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
